export default __webpack_public_path__ + "static/media/avatar.5faf31c1.png";